module.exports = __webpack_public_path__ + "img/priceIcon2.770d4888.png";